/**
 * Quantity spinner - delegated event handlers (no initialization required)
 * Handles +/- buttons; at qty 1, minus dispatches cart:remove-item
 */

const NO_MAX = 9999;

/**
 * Read a numeric attribute, falling back only when it's genuinely absent or unparseable.
 * `parseInt(x) || fallback` would swallow a legitimate 0 (a sold-out cap) as falsy.
 * @param {string} raw
 * @param {number} fallback
 * @returns {number}
 */
function attrNumber(raw, fallback) {
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
}

// Handle +/- button clicks
document.addEventListener("click", (e) => {
  const plus = e.target.closest("[data-quantity-spinner-plus]");
  const minus = e.target.closest("[data-quantity-spinner-minus]");
  if (!plus && !minus) return;

  e.preventDefault(); // Prevent any default button behavior

  const container = (plus || minus).closest("[data-quantity-spinner]");
  const input = container?.querySelector("[data-quantity-spinner-input]");
  if (!input) return;

  const current = parseInt(input.value, 10) || 1;
  const min = attrNumber(input.min, 1);
  const max = attrNumber(input.max, NO_MAX);

  if (plus) {
    input.value = Math.min(current + 1, max);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  } else if (current <= min) {
    // At minimum quantity, dispatch remove event on the cart item element
    const cartItem = container.closest("[data-cart-item]");
    if (cartItem?.dataset.line) {
      cartItem.dispatchEvent(
        new CustomEvent("cart:remove-item", {
          bubbles: true,
          detail: { line: cartItem.dataset.line },
        }),
      );
    }
  } else {
    input.value = Math.max(current - 1, min);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
});

// Validate input changes
document.addEventListener(
  "change",
  (e) => {
    if (!e.target.matches("[data-quantity-spinner-input]")) return;

    const val = parseInt(e.target.value, 10);
    const min = attrNumber(e.target.min, 1);
    const max = attrNumber(e.target.max, NO_MAX);

    if (isNaN(val) || val < min) e.target.value = min;
    else if (val > max) e.target.value = max;
  },
  { capture: true },
);
